export default {"src":"/_next/static/media/GradientPeachGrid.b00340d7.svg","height":768,"width":388,"blurWidth":0,"blurHeight":0};